// store the images of the different GPTs in the public folder of the client app
// use the following function to get the image path
export function getGptIconAsset(icon: string | undefined) : string 
{
    const defaultSyGptLogo = 'sygpt.svg';
    const logoBaseUrl = '/gpts/';
    return logoBaseUrl + (icon ?? defaultSyGptLogo);
}